/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Collapse, Button, Badge, Label, Input, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';

//context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';
import ProviderService from '../../services/ProviderService';

// local imports
import './Session.css';

const Session = props => {

    const today = moment();

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [completeSessionModal, setCompleteSessionModal] = useState({ isVisible: false });
    const [rescheduleSessionModal, setRescheduleSessionModal] = useState({ isVisible: false, message: '' });
    const [cancelSessionModal, setCancelSessionModal] = useState({ isVisible: false, message: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [isLoading3, setIsLoading3] = useState(false);
    const [isResendLoading, setIsResendLoading] = useState(false);
    const [isSessionOpen, setIsSessionOpen] = useState(false);
    const [duration, setDuration] = useState(0);
    const [session, setSession] = useState({
        _id: "",
        time: [],
        date: "",
        modeOfServiceSelected: "",
        isReportIncluded: {},
        provider: "",
        client: "",
        notes: "",
        paymentId: {
            payment: {
                amount: "",
                razorpay_payment_id: ""
            }
        },
        createdByProvider: {
            status: false
        },
        clientSubscriptionId: ""
    });
    const [newUpcomingSession, setNewUpcomingSession] = useState([]);
    const [newRescheduleRequest, setNewRescheduleRequest] = useState([]);
    const [newRescheduledSession, setNewRescheduledSession] = useState([]);
    const [newCancelledSession, setNewCancelledSession] = useState([]);
    const [newRefundProcessed, setNewRefundProcessed] = useState([]);

    // useEffects
    useEffect(() => {
        setIsSessionOpen((props.type === "Upcoming" && props.index === 0) ? true : props.isOpen);
    }, [])

    useEffect(() => {
        if (props.newUpcomingSession) {
            setNewUpcomingSession(props.newUpcomingSession);
        }
    }, [props.newUpcomingSession]);

    useEffect(() => {
        if (props.newRescheduleRequest) {
            setNewRescheduleRequest(props.newRescheduleRequest);
        }
    }, [props.newRescheduleRequest]);

    useEffect(() => {
        if (props.newRescheduledSession) {
            setNewRescheduledSession(props.newRescheduledSession);
        }
    }, [props.newRescheduledSession]);

    useEffect(() => {
        if (props.newCancelledSession) {
            setNewCancelledSession(props.newCancelledSession);
        }
    }, [props.newCancelledSession]);

    useEffect(() => {
        if (props.newRefundProcessed) {
            setNewRefundProcessed(props.newRefundProcessed);
        }
    }, [props.newRefundProcessed]);

    useEffect(() => {
        try {
            if (props.detail) {
                if (props.detail.time.length === 2) {
                    setDuration(moment(props.detail.time[1].to).diff(moment(props.detail.time[0].from), 'minute'));
                } else {
                    setDuration(moment(props.detail.time[0].to).diff(moment(props.detail.time[0].from), 'minute'));
                }
                // console.log("props",props.detail);
                setSession(props.detail);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User Session useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.detail])

    // handle functions

    const handleReschedule = () => {
        props.history.push({
            pathname: "/client/bookSession",
            state: {
                isRescheduled: true,
                selectedTime: session.time,
                selectedDate: session.date,
                sessionId: session._id,
                modeOfServiceSelected: session.modeOfServiceSelected,
                isReportIncluded: session.isReportIncluded
            }
        });
    }

    const handleMarkComplete = () => {
        try {
            setIsLoading(true);
            ProviderService.setSessionCompleted(session._id)
                .then(data => {
                    setSession({ ...session, status: true });
                    setIsLoading(false);
                    setCompleteSessionModal({ isVisible: false });
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                })
                .catch(error => {
                    setIsLoading(false);
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at User Session handleMarkComplete', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }
    }

    const handleCancel = () => {
        try {
            setIsLoading2(true);
            if (cancelSessionModal.message === '') {
                Alert.error("Please enter a message", {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2(false);
                return;
            }
            ProviderService.cancelSession({ id: session._id, date: session.date, time: session.time, message: cancelSessionModal.message })
                .then(data => {
                    setSession({ ...session, isCancelled: true });
                    setIsLoading2(false);
                    setCancelSessionModal({ isVisible: false });
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                })
                .catch(error => {
                    setIsLoading2(false);
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at User Session handleCancel', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }
    }

    const requestRescheduling = e => {
        e.preventDefault();
        try {
            setIsLoading3(true);
            if (rescheduleSessionModal.message === '') {
                Alert.error("Please enter a message", {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading3(false);
                return;
            }
            let sessionList = [];
            sessionList.push({ id: session._id, date: session.date, time: session.time, message: rescheduleSessionModal.message });
            ProviderService.requestRescheduling(sessionList)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading3(false);
                    setSession({ ...session, isRescheduled: true });
                    setRescheduleSessionModal({ isVisible: false, message: '' });
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading3(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading3(false);
            GeneralService.logError('at User Session requestRecheduling', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }
    }

    const resendPaymentLink = (paymentLinkId) => {
        try {
            setIsResendLoading(true);
            ProviderService.reSendPaymentLink({ paymentLinkId, mode: "email" })
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsResendLoading(false);
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsResendLoading(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User Session requestRecheduling', 'Error in try catch block', err.stack);
            setIsResendLoading(false);
        }
    }

    const gotoPaymentPage = (url) => {
        try {
            if (window.confirm("By clicking on OK you will be redirected to RazorPay Payment page")) {
                window.location.href = url;
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User Session gotoPaymentPage', 'Error in try catch block', err.stack);
        }
    }

    // utility functions
    const toggleSession = () => setIsSessionOpen(!isSessionOpen)

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card}>
            <div className="row px-3" onClick={toggleSession} style={{ cursor: "pointer" }}>
                <span style={theme.headingBold}>Session #{props.index > -1 ? props.index + 1 : null} </span>
                <span className="ml-auto" style={theme.headingRegular}>
                    {`${moment(session.date).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format('MMM DD, dddd')} at ${session.time.length > 0 ? session.time.length === 2 ? moment(session.time[0].from).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") + " - " + moment(session.time[1].to).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") : moment(session.time[0].from).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") + " - " + moment(session.time[0].to).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format("hh:mm A") : null}`}
                    {
                        isSessionOpen
                            ? <span className="ml-3" id={`toggleSession${props.type}${props.index}`}>
                                <i className="fas fa-angle-up"></i>
                                {newUpcomingSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRescheduleRequest.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRescheduledSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>Rescheduled</Badge> : null}
                                {newCancelledSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRefundProcessed.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>Refunded</Badge> : null}
                            </span>
                            : <span className="ml-3" id={`toggleSession${props.type}${props.index}`}>
                                <i className="fas fa-angle-down"></i>
                                {newUpcomingSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRescheduleRequest.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRescheduledSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>Rescheduled</Badge> : null}
                                {newCancelledSession.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>New</Badge> : null}
                                {newRefundProcessed.includes(session._id) ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>Refunded</Badge> : null}
                            </span>
                    }
                </span>
            </div>

            <Collapse isOpen={isSessionOpen}>
                <hr />
                <div className="my-auto sessionDiv" style={theme.paragraph}>
                    <Table borderless>
                        <tbody>
                            {
                                session.provider ?
                                    [<tr key="1">
                                        <td id="session-counsellor-name" className="sessionInfoTitle">
                                            <span>Counsellor Name</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.provider.title ? session.provider.title : ''} {session.provider.firstName} {session.provider.lastName}</span>
                                        </td>
                                    </tr>,
                                    <tr key="2">
                                        <td id="session-counsellor-email" className="sessionInfoTitle">
                                            <span>Counsellor Email</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.provider.email}</span>
                                        </td>
                                    </tr>]
                                    :
                                    [<tr key="1">
                                        <td id="session-client-name" className="sessionInfoTitle">
                                            <span>Client Name</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.client.title ? session.client.title : ''} {session.client.firstName} {session.client.lastName}</span>
                                        </td>
                                    </tr>,
                                    <tr key="2">
                                        <td id="session-client-email" className="sessionInfoTitle">
                                            <span>Client Email</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">{session.client.email}</span>
                                        </td>
                                    </tr>]
                            }
                            {/* <div className="sessionInfoGroup"> */}
                            <tr>
                                <td id="session-booked-on" className="sessionInfoTitle">
                                    <span>Booked on</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{moment(session.createdAt).utcOffset(props.selectedTimeZone ? props.selectedTimeZone.isDST ? props.selectedTimeZone.dst_offset : props.selectedTimeZone.offset : "+05:30").format('MMM DD, YYYY [at] hh:mm A')}</span>
                                </td>
                            </tr>
                            <tr>
                                <td id="session-duration" className="sessionInfoTitle">
                                    <span>Duration</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{duration === 60 ? "1 hour" : "30 minutes"}</span>
                                </td>
                            </tr>
                            <tr>
                                <td id="session-mode-of-service" className="sessionInfoTitle">
                                    <span>Mode of Service</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.modeOfServiceSelected}</span>
                                </td>
                            </tr>
                            <tr>
                                <td id="session-report-included" className="sessionInfoTitle">
                                    <span>Session Report included</span>
                                </td>
                                <td>
                                    <span className="sessionInfoDetail">{session.isReportIncluded ? session.isReportIncluded.status ? `Yes for ₹${session.isReportIncluded.amount}` : "No" : "No"}</span>
                                </td>
                            </tr>
                            {/* pending */}
                            {
                                session.couponApplied ?
                                    <tr>
                                        <td id="session-coupon-applied" className="sessionInfoTitle">
                                            <span>Coupon applied</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">₹{session.paymentId.payment.coupon.value.toFixed(2)}</span>
                                        </td>
                                    </tr> : null
                            }
                            {
                                session.voucherApplied ?
                                    <tr>
                                        <td id="session-giftvoucher-applied" className="sessionInfoTitle">
                                            <span>GiftVoucher applied</span>
                                        </td>
                                        <td>
                                            <span className="sessionInfoDetail">₹{session.paymentId.payment.voucher.value.toFixed(2)}</span>
                                        </td>
                                    </tr> : null
                            }
                            {
                                session.createdByProvider.status && session.paymentId === undefined ?
                                    session.client ?
                                        <tr>
                                            <td className="sessionInfoTitle">
                                                <span>Payment link Status</span>
                                            </td>
                                            <td>
                                                <span style={{ textTransform: 'capitalize' }} className="sessionInfoDetail">{session.createdByProvider.paymentLinkStatus === "created" ? "Payment pending" : `Payment ${session.createdByProvider.paymentLinkStatus}`}</span>
                                            </td>
                                        </tr>
                                        : null
                                    :
                                    [
                                        <tr key="1">
                                            <td id="session-amout-paid" className="sessionInfoTitle">
                                                <span>Amount Paid</span>
                                            </td>
                                            <td>
                                                <span className="sessionInfoDetail">{session.clientSubscriptionId ? 'Booked under subscription' : '₹' + session.paymentId.payment === 'Free Session' ? 0 : session.paymentId.payment.amount}</span>
                                            </td>
                                        </tr>,
                                        session.clientSubscriptionId || session.paymentId && session.paymentId.payment === 'Free Session' ? null :
                                            session.paymentId.payment.amount === '0.00' ? null :
                                                <tr key="2">
                                                    <td id="session-transaction-id" className="sessionInfoTitle">
                                                        <span>Transaction ID</span>
                                                    </td>
                                                    <td>
                                                        <span className="sessionInfoDetail">{session.paymentId.payment.razorpay_payment_id}</span>
                                                    </td>
                                                </tr>,
                                        session.isRescheduled ?
                                            <tr key="3">
                                                <td id='session-reschedule-request' className="sessionInfoTitle">
                                                    <span>Reschedule requested</span>
                                                </td>
                                                <td>
                                                    <span className="sessionInfoDetail">{session.isRescheduled ? "Yes" : "No"}</span>
                                                </td>
                                            </tr>
                                            : null,
                                        session.isCancelled ?
                                            <tr key="4">
                                                <td className="sessionInfoTitle">
                                                    <span>Is refunded</span>
                                                </td>
                                                <td>
                                                    <span className="sessionInfoDetail">{session.refundProcessed ? "Yes" : "No"}</span>
                                                </td>
                                            </tr>
                                            : null
                                    ]
                            }
                        </tbody>
                    </Table>
                    <div className="row pl-3">
                        {
                            props.mode != "reschedule" && session.client && (session.paymentId || session.clientSubscriptionId) ?
                                <div className="ml-auto">

                                    <Button className="btn mt-3 mr-3" style={theme.button} onClick={() => props.handleModal({ visible: true, sessionId: session._id, sessionStatus: props.type, sessionIndex: props.index, notes: session.notes })} id={`notesBtn${props.index}`}>Notes</Button>
                                    {
                                        session.isCancelled ? null :
                                            session.status ? null : [
                                                session.isRescheduled ? null : <Button key="reBtn" className="btn mt-3 mr-3" style={theme.button} onClick={() => setRescheduleSessionModal({ isVisible: true, message: '' })} id={`requestRescheduleBtn${props.index}`}>Request Rescheduling</Button>,
                                                moment(moment(session.date).format('DD MMMM YYYY') + ' ' + session.time.slice(11), 'DD MMMM YYYY hh:mm A').isAfter(today) ? null : <Button key="comBtn" className="btn mt-3 mr-3" style={theme.button} onClick={() => setCompleteSessionModal({ isVisible: true })} id={`markCompleteBtn${props.index}`}>Mark completed</Button>,
                                                session.isRescheduled ? null : [
                                                    session.paymentId && session.paymentId.payment === 'Free Session' ? null : <Button key="canBtn" className="btn mt-3 mr-3" style={theme.button} onClick={() => setCancelSessionModal({ isVisible: true, message: '' })} id={`cancelBtn${props.index}`}>Cancel</Button>,
                                                    <Link key="meetLink" to={{ pathname: "/counsellor/meet", state: { duration: duration } }}>
                                                        <Button className="btn mt-3 mr-3" style={theme.button} id={`meetBtn${props.index}`}>Start Meet</Button>
                                                    </Link>
                                                ],
                                            ]
                                    }
                                </div>
                                : null
                        }
                        {
                            session.provider && session.isRescheduled ?
                                <Button className="btn ml-auto mt-3 mr-3" style={theme.button} onClick={handleReschedule} id={`rescheduleBtn${props.index}`}>Reschedule</Button>
                                : null
                        }
                        {
                            session.createdByProvider.status && session.paymentId === undefined ?
                                session.provider ?
                                    <Button className="btn ml-auto mt-3 mr-3" style={theme.button} onClick={() => gotoPaymentPage(session.createdByProvider.paymentLink)} id={`paynowBtn${props.index}`}>Pay now</Button>
                                    : session.client ?
                                        <Button className="btn ml-auto mt-3 mr-3" style={theme.button} onClick={() => resendPaymentLink(session.createdByProvider.paymentLinkId)} id={`resendBtn${props.index}`}>{isResendLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Resend payment link</Button>
                                        : null
                                : null
                        }
                    </div>
                </div>
            </Collapse>
            <Modal size="sm" id="markCompleteModel" isOpen={completeSessionModal.isVisible} backdrop={true}>
                <ModalHeader id="mark-completed-heading" close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setCompleteSessionModal({ isVisible: false })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Confirmation</span></ModalHeader>
                <ModalBody id="mark-completed-warnings">
                    <p><strong>Are you sure?</strong></p>
                    <p>This session will be marked as completed.</p>
                    <p className="text-danger">This operation can not be undone.</p>
                </ModalBody>
                <ModalFooter>
                    <Button id="mark-completed-cancel-btn" type="button" style={theme.formButton} className="btn btn-outline-secondary" onClick={() => setCompleteSessionModal({ isVisible: false })}>Cancel</Button>
                    <Button id="mark-completed-ok-btn" type="button" style={theme.formButton} className="btn btn-danger" onClick={handleMarkComplete} disabled={isLoading}>
                        {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Ok
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal size="sm" id="cancelModel" isOpen={cancelSessionModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setCancelSessionModal({ isVisible: false, message: '' })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Your message to client</span></ModalHeader>
                <ModalBody>
                    <Label>Please enter message, this will be sent to your client.</Label>
                    <Input type="textarea" id="message" style={{ height: '180px' }} name="message" onChange={(e) => setCancelSessionModal({ ...cancelSessionModal, message: e.target.value })} />
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={handleCancel} disabled={isLoading2}>
                        {isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal size="lg" id="rescheduleModel" isOpen={rescheduleSessionModal.isVisible} backdrop={true}>
                <ModalHeader id="reschedule-heading" close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setRescheduleSessionModal({ isVisible: false, message: '' })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Your message to client(s)</span></ModalHeader>
                <ModalBody>
                    <Label id="reschedule-text">Please enter reason for rescheduling, this message will be sent to your client.</Label>
                    <Input type="textarea" id="message" style={{ height: '180px' }} name="message" onChange={(e) => setRescheduleSessionModal({ ...rescheduleSessionModal, message: e.target.value })} />
                </ModalBody>
                <ModalFooter>
                    <Button id="reschedule-save-btn" type="button" style={theme.formButton} className="btn btn-danger" onClick={requestRescheduling} disabled={isLoading3}>
                        {isLoading3 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )

}

export default Session;